module.exports = __webpack_public_path__ + "static/media/08kcsg1.a732f3c0.png";